import { Link } from "react-router";
import { useAlertCounts } from "@/hooks/useAlertCounts";

export default function AlertsMenuItem() {
  const { alertedCount } = useAlertCounts();

  return (
    <Link to="alerts" className="flex items-center justify-between gap-2">
      <span>Alerts</span>
      {alertedCount > 0 && (
        <div
          className="bg-[#EBD1E0] text-[#73134A] rounded-full px-2 py-1 text-xs"
          data-testid="alerts-nav-count"
        >
          {alertedCount}
        </div>
      )}
    </Link>
  );
}
